import React from 'react';

const Terms = () => {
    return (
        <div data-testid="termsOfUse" className="termsOfUse">
            <a href="https://www.epo.org/searching-for-patents/data/linked-open-data.html#tab-2">Terms of use</a>
        </div>
    );
};

export default Terms;
